import { useState } from "react";
import CheckboxesTreeDropdown from "./checkboxes-tree-dropdown";
import { ICheckboxesTreeItem } from "./checkboxes-tree/stores/checkboxes-tree-store";
import { Toggle } from "../toggle/toggle";

const options: ICheckboxesTreeItem[] = [
    {
        "value": "Allied_Express",
        "label": "Allied Express",
        "childNodes": [
            {
                "value": "Allied_Express_Road_Express",
                "label": "Allied Express - Road Express",
                // "disabled": true
            }
        ]
    },
    {
        "value": "Aramex",
        "label": "Aramex",
        "childNodes": [
            {
                "value": "Aramex_Domestic_Pick_up_to_delivery",
                "label": "Aramex - Domestic (Pick up to delivery)",
            },
            {
                "value": "Aramex_Parcel",
                "label": "Aramex - Parcel",
                "childNodes": [
                    {
                        "value": "Aramex_Parcel_NESTED_1",
                        "label": "Aramex - Aramex_Parcel_NESTED_1",
                    },
                    {
                        "value": "Aramex_Parcel_NESTED_2",
                        "label": "Aramex - Aramex_Parcel_NESTED_2",
                    },
                ]
            },
            {
                "value": "Aramex_Parcel_Domestic",
                "label": "Aramex - Parcel (Domestic)",
                "childNodes": [
                    {
                        "value": "Aramex_Parcel_Domestic_NESTED_1",
                        "label": "Aramex - Domestic Aramex_Parcel_Domestic_NESTED_1",
                        "childNodes": [
                            {
                                "value": "Aramex_Parcel_Domestic_NESTED_1_1",
                                "label": "Aramex - Aramex_Parcel_Domestic_NESTED_1_1",
                                // "disabled": true
                            },
                            {
                                "value": "Aramex_Parcel_Domestic_NESTED_1_2",
                                "label": "Aramex - Aramex_Parcel_Domestic_NESTED_1_2",
                                // "disabled": true
                            },
                        ]
                    },
                    {
                        "value": "Aramex_Parcel_Domestic_NESTED_2",
                        "label": "Aramex - Aramex_Parcel_Domestic_NESTED_2",
                        // "disabled": true
                    },
                ]
            },
            {
                "value": "Aramex_Parcel_EPX_hybrid_EU_and_US",
                "label": "Aramex - Parcel EPX (hybrid EU and US)",
            },
            {
                "value": "Aramex_Parcel_to_SA_and_AE_DDP",
                "label": "Aramex - Parcel to SA and AE (DDP)",
            }
        ]
    },
    {
        "value": "Asendia",
        "label": "Asendia",
        "childNodes": [
            {
                "value": "Asendia_ePAQ_Plus_DDUHVN",
                "label": "Asendia - ePAQ Plus (DDUHVN)",
            },
            {
                "value": "Asendia_ePAQ_Plus_DDULAX",
                "label": "Asendia - ePAQ Plus (DDULAX)",
            },
            {
                "value": "Asendia_ePAQ_Plus_DDUMIA",
                "label": "Asendia - ePAQ Plus (DDUMIA)",
            },
            {
                "value": "Asendia_ePAQ_Plus_DDUORD",
                "label": "Asendia - ePAQ Plus (DDUORD)",
            },
            {
                "value": "Asendia_ePAQ_Plus_DDUPHL",
                "label": "Asendia - ePAQ Plus (DDUPHL)",
            },
            {
                "value": "Asendia_Epaq_Plus_Hermes",
                "label": "Asendia - Epaq Plus (Hermes)",
            },
            {
                "value": "Asendia_ePAQ_Select_HVN",
                "label": "Asendia - ePAQ Select (HVN)",
            },
            {
                "value": "Asendia_ePAQ_Select_LAX_Hermes",
                "label": "Asendia - ePAQ Select LAX (Hermes)",
            },
            {
                "value": "Asendia_ePAQ_Select_MIA",
                "label": "Asendia - ePAQ Select (MIA)",
            },
            {
                "value": "Asendia_ePAQ_Select_ORD",
                "label": "Asendia - ePAQ Select (ORD)",
            },
            {
                "value": "Asendia_ePAQ_Select_PHL",
                "label": "Asendia - ePAQ Select (PHL)",
            },
            {
                "value": "Asendia_ePAQ_Standard_HVN",
                "label": "Asendia - ePAQ Standard (HVN)",
            },
            {
                "value": "Asendia_ePAQ_Standard_LAX",
                "label": "Asendia - ePAQ Standard (LAX)",
            },
            {
                "value": "Asendia_ePAQ_Standard_MIA",
                "label": "Asendia - ePAQ Standard (MIA)",
            },
            {
                "value": "Asendia_ePAQ_Standard_ORD",
                "label": "Asendia - ePAQ Standard (ORD)",
            },
            {
                "value": "Asendia_ePAQ_Standard_PHL",
                "label": "Asendia - ePAQ Standard (PHL)",
            }
        ]
    },
    {
        "value": "BPOST",
        "label": "BPOST",
        "childNodes": [
            {
                "value": "Belgium_Post_Domestic",
                "label": "Belgium Post - Domestic",
            },
            {
                "value": "Belgium_Post_international",
                "label": "Belgium Post - international",
            }
        ]
    },
    {
        "value": "Bringer",
        "label": "Bringer",
        "childNodes": [
            {
                "value": "Bringer_Packet_Standard_MIA",
                "label": "Bringer - Packet Standard (MIA)",
            }
        ]
    },
    {
        "value": "BRT",
        "label": "BRT",
        "childNodes": [
            {
                "value": "BRT_Return",
                "label": "BRT - Return",
            }
        ]
    },
    {
        "value": "Canada_Post",
        "label": "Canada Post",
        "childNodes": [
            {
                "value": "Canada_Post_Expedited_Parcel",
                "label": "Canada Post - Expedited Parcel",
            },
            {
                "value": "Canada_Post_Expedited_Parcel_USA",
                "label": "Canada Post - Expedited Parcel - USA",
            },
            {
                "value": "Canada_Post_International_Parcel_Air",
                "label": "Canada Post - International Parcel - Air",
            },
            {
                "value": "Canada_Post_International_Parcel_Surface",
                "label": "Canada Post - International Parcel - Surface",
            },
            {
                "value": "Canada_Post_International_Small_Packet_Surface",
                "label": "Canada Post - International Small Packet - Surface",
            },
            {
                "value": "Canada_Post_International_Tracked_Packet",
                "label": "Canada Post - International Tracked Packet",
            },
            {
                "value": "Canada_Post_Priority",
                "label": "Canada Post - Priority",
            },
            {
                "value": "Canada_Post_Regular_Parcel",
                "label": "Canada Post - Regular Parcel",
            },
            {
                "value": "Canada_Post_Small_Packet_International_Air",
                "label": "Canada Post - Small Packet International - Air",
            },
            {
                "value": "Canada_Post_Small_Packet_USA",
                "label": "Canada Post - Small Packet - USA",
            },
            {
                "value": "Canada_Post_USA_Tracked_Parcel",
                "label": "Canada Post - USA Tracked Parcel",
            },
            {
                "value": "Canada_Post_Xpresspost",
                "label": "Canada Post - Xpresspost",
            },
            {
                "value": "Canada_Post_Xpresspost_International",
                "label": "Canada Post - Xpresspost - International",
            },
            {
                "value": "Canada_Post_Xpresspost_USA",
                "label": "Canada Post - Xpresspost - USA",
            }
        ]
    },
    {
        "value": "Canpar",
        "label": "Canpar",
        "childNodes": [
            {
                "value": "Canpar_Express",
                "label": "Canpar - Express",
            },
            {
                "value": "Canpar_Express_Pak",
                "label": "Canpar - Express Pak",
            },
            {
                "value": "Canpar_Ground",
                "label": "Canpar - Ground",
            },
            {
                "value": "Canpar_International",
                "label": "Canpar - International",
            },
            {
                "value": "Canpar_Select",
                "label": "Canpar - Select",
            },
            {
                "value": "Canpar_Select_Pak",
                "label": "Canpar - Select Pak",
            },
            {
                "value": "Canpar_Select_USA",
                "label": "Canpar - Select USA",
            },
            {
                "value": "Canpar_USA",
                "label": "Canpar - USA",
            },
            {
                "value": "Canpar_USA_Pak",
                "label": "Canpar - USA Pak",
            }
        ]
    },
    {
        "value": "Chronopost",
        "label": "Chronopost",
        "childNodes": [
            {
                "value": "Chronopost_Chrono_10",
                "label": "Chronopost - Chrono 10",
            },
            {
                "value": "Chronopost_Chrono_13",
                "label": "Chronopost - Chrono 13",
            },
            {
                "value": "Chronopost_Chrono_18",
                "label": "Chronopost - Chrono 18",
            },
            {
                "value": "Chronopost_Chrono_Classic",
                "label": "Chronopost - Chrono Classic",
            },
            {
                "value": "Chronopost_Chrono_Express",
                "label": "Chronopost - Chrono Express",
            }
        ]
    },
    {
        "value": "Colis_Prive",
        "label": "Colis Prive",
        "childNodes": [
            {
                "value": "Colis_Prive_Home",
                "label": "Colis Prive - Home",
            }
        ]
    },
    {
        "value": "Colissimo",
        "label": "Colissimo",
        "childNodes": [
            {
                "value": "Colissimo_Access",
                "label": "Colissimo - Access",
            },
            {
                "value": "Colissimo_Expert",
                "label": "Colissimo - Expert",
            },
            {
                "value": "Colissimo_Home_return",
                "label": "Colissimo - Home return",
            },
            {
                "value": "Colissimo_International",
                "label": "Colissimo - International",
            },
            {
                "value": "Colissimo_International_Return",
                "label": "Colissimo - International Return",
            },
            {
                "value": "Colissimo_International_Return_bulky",
                "label": "Colissimo - International Return bulky",
            },
            {
                "value": "Colissimo_International_Return_new",
                "label": "Colissimo - International Return new",
            }
        ]
    },
    {
        "value": "Correos",
        "label": "Correos",
        "childNodes": [
            {
                "value": "Correos_Returns",
                "label": "Correos - Returns",
            }
        ]
    },
    {
        "value": "CouriersPlease",
        "label": "CouriersPlease",
        "childNodes": [
            {
                "value": "CouriersPlease_Authority_To_Leave_0_5kg_0_5kg",
                "label": "CouriersPlease - Authority To Leave - 0.5kg (0.5kg)",
            },
            {
                "value": "CouriersPlease_Authority_To_Leave_10kg_10kilo",
                "label": "CouriersPlease - Authority To Leave - 10kg (10kilo)",
            },
            {
                "value": "CouriersPlease_Authority_To_Leave_1kg_1kilo",
                "label": "CouriersPlease - Authority To Leave - 1kg (1kilo)",
            },
            {
                "value": "CouriersPlease_Authority_To_Leave_25kg_25kilo",
                "label": "CouriersPlease - Authority To Leave - 25kg (25kilo)",
            },
            {
                "value": "CouriersPlease_Authority_To_Leave_3kg_3kilo",
                "label": "CouriersPlease - Authority To Leave - 3kg (3kilo)",
            },
            {
                "value": "CouriersPlease_Authority_To_Leave_5kg_5kilo",
                "label": "CouriersPlease - Authority To Leave - 5kg (5kilo)",
            },
            {
                "value": "CouriersPlease_Multi_Box_Pronto",
                "label": "CouriersPlease - Multi Box Pronto",
            },
            {
                "value": "CouriersPlease_Multi_Box_STD",
                "label": "CouriersPlease - Multi Box STD",
            },
            {
                "value": "CouriersPlease_Signature_0_5kg_0_5kg",
                "label": "CouriersPlease - Signature - 0.5kg (0.5kg)",
            },
            {
                "value": "CouriersPlease_Signature_10kg_10kg",
                "label": "CouriersPlease - Signature - 10kg (10kg)",
            },
            {
                "value": "CouriersPlease_Signature_1kg_1kg",
                "label": "CouriersPlease - Signature - 1kg (1kg)",
            },
            {
                "value": "CouriersPlease_Signature_3kg_3kg",
                "label": "CouriersPlease - Signature - 3kg (3kg)",
            },
            {
                "value": "CouriersPlease_Signature_5kg_5kg",
                "label": "CouriersPlease - Signature - 5kg (5kg)",
            }
        ]
    },
    {
        "value": "CTT",
        "label": "CTT",
        "childNodes": [
            {
                "value": "CTT_Devolucion_Recogida_24_AM",
                "label": "CTT - Devolucion + Recogida 24 AM",
            },
            {
                "value": "CTT_Devolucion_Recogida_24_PM",
                "label": "CTT - Devolucion + Recogida 24 PM",
            },
            {
                "value": "CTT_Devolucion_Recogida_48_AM",
                "label": "CTT - Devolucion + Recogida 48 AM",
            },
            {
                "value": "CTT_Devolucion_Recogida_48_PM",
                "label": "CTT - Devolucion + Recogida 48 PM",
            },
            {
                "value": "CTT_Devolucion_Recogida_AM_Baleares_Economy",
                "label": "CTT - Devolucion + Recogida AM Baleares Economy",
            },
            {
                "value": "CTT_Devolucion_Recogida_AM_Baleares_Express",
                "label": "CTT - Devolucion + Recogida AM Baleares Express",
            },
            {
                "value": "CTT_Devolucion_Recogida_PM_Baleares_Economy",
                "label": "CTT - Devolucion + Recogida PM Baleares Economy",
            },
            {
                "value": "CTT_Devolucion_Recogida_PM_Baleares_Express",
                "label": "CTT - Devolucion + Recogida PM Baleares Express",
            },
            {
                "value": "CTT_EasyReturn",
                "label": "CTT - EasyReturn",
            },
            {
                "value": "CTT_Express_Balearic_Pick_Return",
                "label": "CTT - Express Balearic Pick + Return",
            },
            {
                "value": "CTT_Express_Pick_Return",
                "label": "CTT - Express Pick + Return",
            }
        ]
    },
    {
        "value": "DHL",
        "label": "DHL",
        "childNodes": [
            {
                "value": "DHL_Documents",
                "label": "DHL - Documents",
            },
            {
                "value": "DHL_Domestic_Express",
                "label": "DHL - Domestic Express",
            },
            {
                "value": "DHL_Express",
                "label": "DHL - Express",
                "countries": [
                    "NL",
                    "FR"
                ]
            },
            {
                "value": "DHL_Express_0900",
                "label": "DHL - Express 0900",
            },
            {
                "value": "DHL_Express_1200",
                "label": "DHL - Express 1200",
            },
            {
                "value": "DHL_Express_Worldwide_Easyship",
                "label": "DHL - Express Worldwide (Easyship)",
            }
        ]
    },
    {
        "value": "DHL_DE",
        "label": "DHL DE",
        "childNodes": [
            {
                "value": "DHL_Economy_Select",
                "label": "DHL - Economy Select",
            },
            {
                "value": "DHL_Express_09",
                "label": "DHL - Express 09",
            },
            {
                "value": "DHL_Express_10_30",
                "label": "DHL - Express 10:30",
            },
            {
                "value": "DHL_Express_12",
                "label": "DHL - Express 12",
            },
            {
                "value": "DHL_Express_18",
                "label": "DHL - Express 18",
            },
            {
                "value": "DHL_Express_Worldwide",
                "label": "DHL - Express Worldwide",
            },
            {
                "value": "DHL_Paket_Return",
                "label": "DHL- Paket Return",
            },
            {
                "value": "DHL_Paket_Return_service_point",
                "label": "DHL- Paket Return service point",
            }
        ]
    },
    {
        "value": "DHL_Express",
        "label": "DHL Express",
        "childNodes": [
            {
                "value": "DHL_Express_Worldwide",
                "label": "DHL Express - Worldwide",
                "countries": [
                    "US",
                    "NL"
                ]
            }
        ]
    },
    {
        "value": "DPD",
        "label": "DPD",
        "childNodes": [
            {
                "value": "DPD_Air_Classic",
                "label": "DPD - Air Classic",
            },
            {
                "value": "DPD_Classic_Expresspak",
                "label": "DPD - Classic Expresspak",
            },
            {
                "value": "DPD_Classic_Parcel",
                "label": "DPD - Classic Parcel",
            },
            {
                "value": "DPD_Expresspak_Next_Day_NextDay",
                "label": "DPD - Expresspak Next Day (NextDay)",
            },
            {
                "value": "DPD_Parcel_IOSS",
                "label": "DPD - Parcel (IOSS)",
            }
        ]
    },
    {
        "value": "DPD_AT",
        "label": "DPD AT",
        "childNodes": [
            {
                "value": "DPD_Austria_Return",
                "label": "DPD Austria - Return",
                "countries": [
                    "AT"
                ]
            }
        ]
    },
    {
        "value": "DPD_DE",
        "label": "DPD DE",
        "childNodes": [
            {
                "value": "DPD_Classic_return",
                "label": "DPD - Classic return",
            },
            {
                "value": "DPD_Home_Return",
                "label": "DPD - Home Return",
            },
            {
                "value": "DPD_Return",
                "label": "DPD - Return",
            }
        ]
    },
    {
        "value": "DPD_FR",
        "label": "DPD FR",
        "childNodes": [
            {
                "value": "DPD_Predict_Return",
                "label": "DPD - Predict Return",
            },
            {
                "value": "DPD_Relais_Return",
                "label": "DPD - Relais Return",
            }
        ]
    },
    {
        "value": "Evri_Hermes",
        "label": "Evri (Hermes)",
        "childNodes": [
            {
                "value": "Evri_Collection_Return_Standard_Delivery",
                "label": "Evri - Collection Return Standard Delivery",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "Evri_International_Parcelshop",
                "label": "Evri - International Parcelshop",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "Evri_Light_and_Large",
                "label": "Evri - Light and Large",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "Evri_Locker_to_Address_Returns",
                "label": "Evri - Locker to Address Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "Evri_Next_Day_Parcelshop",
                "label": "Evri - Next Day Parcelshop",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "Evri_Parcelshop_Returns",
                "label": "Evri - Parcelshop Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "Evri_Parcelshop_to_Address_QR_Returns",
                "label": "Evri - Parcelshop to Address QR Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "Evri_Parcelshop_to_Address_Returns",
                "label": "Evri - Parcelshop to Address Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "Evri_Postable_Next_Day",
                "label": "Evri - Postable Next Day",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "Evri_Returns",
                "label": "Evri - Returns",
                "countries": [
                    "GB"
                ]
            }
        ]
    },
    {
        "value": "FedEx",
        "label": "FedEx",
        "childNodes": [
            {
                "value": "FedEx_2Day_R",
                "label": "FedEx 2Day®",
            },
            {
                "value": "FedEx_2Day_R_A_M",
                "label": "FedEx 2Day® A.M.",
            },
            {
                "value": "FedEx_Economy_Returns",
                "label": "FedEx - Economy Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_Europe_first_Returns",
                "label": "FedEx - Europe first Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_Express_Saver_R",
                "label": "FedEx Express Saver®",
            },
            {
                "value": "FedEx_Global_Returns",
                "label": "FedEx - Global Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_Ground_R",
                "label": "FedEx Ground®",
            },
            {
                "value": "FedEx_Ground_R_Economy",
                "label": "FedEx Ground® Economy",
            },
            {
                "value": "FedEx_Home_Delivery_R",
                "label": "FedEx Home Delivery®",
            },
            {
                "value": "FedEx_International_Connect_Plus_Returns",
                "label": "FedEx - International Connect Plus Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_International_Economy_MyFlyingBox",
                "label": "FedEx - International Economy (MyFlyingBox)",
            },
            {
                "value": "FedEx_International_Economy_R",
                "label": "FedEx International Economy®",
            },
            {
                "value": "FedEx_International_Economy_Returns",
                "label": "FedEx - International Economy Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_International_first_Returns",
                "label": "FedEx - International first Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_International_Priority_MyFlyingBox",
                "label": "FedEx - International Priority (MyFlyingBox)",
            },
            {
                "value": "FedEx_International_Priority_OWC",
                "label": "FedEx - International Priority (OWC)",
            },
            {
                "value": "FedEx_International_Priority_R",
                "label": "FedEx International Priority®",
                "countries": [
                    "SG",
                    "US"
                ]
            },
            {
                "value": "FedEx_International_Priority_Returns",
                "label": "FedEx - International Priority Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_Priority_Overnight_R",
                "label": "FedEx Priority Overnight®",
            },
            {
                "value": "FedEx_Priority_Overnight_Returns",
                "label": "FedEx - Priority Overnight Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_R_International_Connect_Plus",
                "label": "FedEx® International Connect Plus",
            },
            {
                "value": "FedEx_Regional_Economy_Freight_Returns",
                "label": "FedEx - Regional Economy Freight Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_Returns",
                "label": "FedEx - Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "FedEx_Standard_Overnight_R",
                "label": "FedEx Standard Overnight®",
            }
        ]
    },
    {
        "value": "GlobalPost",
        "label": "GlobalPost",
        "childNodes": [
            {
                "value": "GlobalPost_Economy",
                "label": "GlobalPost - Economy",
            },
            {
                "value": "GlobalPost_Standard",
                "label": "GlobalPost - Standard",
            }
        ]
    },
    {
        "value": "HK_Post",
        "label": "HK Post",
        "childNodes": [
            {
                "value": "HK_Post_Air_Mail_Tracking",
                "label": "HK Post Air Mail - Tracking",
            },
            {
                "value": "HK_Post_Air_Parcel_PE_P",
                "label": "HK Post - Air Parcel PE (P)",
            },
            {
                "value": "HK_Post_Air_Parcel_XP",
                "label": "HK Post - Air Parcel XP",
            },
            {
                "value": "HK_Post_e_Express",
                "label": "HK Post - e-Express+",
            },
            {
                "value": "HK_Post_Local_Parcel",
                "label": "HK Post - Local Parcel",
            },
            {
                "value": "HK_Post_Speedpost",
                "label": "HK Post - Speedpost",
            }
        ]
    },
    {
        "value": "Hubbed_Easy_Returns",
        "label": "Hubbed Easy Returns",
        "childNodes": [
            {
                "value": "Hubbed_Easy_Returns",
                "label": "Hubbed Easy Returns",
            }
        ]
    },
    {
        "value": "InPost",
        "label": "InPost",
        "childNodes": [
            {
                "value": "InPost_Instant_Returns",
                "label": "InPost - Instant Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "InPost_Locker_2_Locker_Returns",
                "label": "InPost - Locker 2 Locker Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "InPost_Locker_to_Address_Returns",
                "label": "InPost - Locker to Address Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "value": "InPost_Returns",
                "label": "InPost - Returns",
                "countries": [
                    "GB"
                ]
            }
        ]
    },
    {
        "value": "InPost_ES",
        "label": "InPost ES",
        "childNodes": [
            {
                "value": "InPost_Devolucion_Punto_de_Servicio_Internacional",
                "label": "InPost - Devolucion Punto de Servicio Internacional",
            },
            {
                "value": "InPost_Devolucion_Punto_de_Servicio_Internacional_QR",
                "label": "InPost - Devolucion Punto de Servicio Internacional QR",
            },
            {
                "value": "InPost_Devolucion_Punto_de_Servicio_Nacional",
                "label": "InPost - Devolucion Punto de Servicio Nacional",
            },
            {
                "value": "InPost_Devolucion_Punto_de_Servicio_Nacional_QR",
                "label": "InPost - Devolucion Punto de Servicio Nacional QR",
            },
            {
                "value": "InPost_Internacional_Devolucion",
                "label": "InPost - Internacional Devolucion",
            },
            {
                "value": "InPost_Nacional_Devolucion",
                "label": "InPost - Nacional Devolucion",
            },
            {
                "value": "InPost_Nacional_Devolucion_QR",
                "label": "InPost - Nacional Devolucion QR",
            },
            {
                "value": "InPost_Punto_Pack_I_Locker_Retorno",
                "label": "InPost - Punto Pack I Locker - Retorno",
            },
            {
                "value": "InPost_Punto_Pack_International_Retorno",
                "label": "InPost - Punto Pack International - Retorno",
            }
        ]
    },
    {
        "value": "InPost_IT",
        "label": "InPost IT",
        "childNodes": [
            {
                "value": "InPost_International_Returns",
                "label": "InPost - International Returns",
            },
            {
                "value": "InPost_Returns",
                "label": "InPost - Returns",
            }
        ]
    },
    {
        "value": "J_T_Express",
        "label": "J&T Express",
        "childNodes": [
            {
                "value": "J_T_Express_Domestic",
                "label": "J&T Express - Domestic",
            }
        ]
    },
    {
        "value": "Janio",
        "label": "Janio",
        "childNodes": [
            {
                "value": "Janio_Express",
                "label": "Janio - Express",
            }
        ]
    },
    {
        "value": "Mondial_Realy",
        "label": "Mondial Realy",
        "childNodes": [
            {
                "value": "Mondial_Relay_International_home",
                "label": "Mondial Relay - International, home",
            },
            {
                "value": "Mondial_Relay_International_home_QR",
                "label": "Mondial Relay - International, home, QR",
            },
            {
                "value": "Mondial_Relay_International_return",
                "label": "Mondial Relay - International return",
            },
            {
                "value": "Mondial_Relay_International_return_QR",
                "label": "Mondial Relay - International return, QR",
            },
            {
                "value": "Mondial_Relay_International_return_relay",
                "label": "Mondial Relay - International return relay",
            },
            {
                "value": "Mondial_Relay_International_return_relay_QR",
                "label": "Mondial Relay - International return relay, QR",
            },
            {
                "value": "Mondial_Relay_Return",
                "label": "Mondial Relay - Return",
            },
            {
                "value": "Mondial_Relay_Return_QR",
                "label": "Mondial Relay - Return, QR",
            },
            {
                "value": "Mondial_Relay_Return_relay",
                "label": "Mondial Relay - Return relay",
            }
        ]
    },
    {
        "value": "NinjaVan",
        "label": "NinjaVan",
        "childNodes": [
            {
                "value": "NinjaVan_Next_Day",
                "label": "NinjaVan Next Day",
            },
            {
                "value": "NinjaVan_Standard",
                "label": "NinjaVan Standard",
            }
        ]
    },
    {
        "value": "NZ_Post",
        "label": "NZ Post",
        "childNodes": [
            {
                "value": "NZ_Post_Air_Small_Parcel",
                "label": "NZ Post - Air Small Parcel",
            },
            {
                "value": "NZ_Post_Economy_Parcel",
                "label": "NZ Post - Economy Parcel",
            },
            {
                "value": "NZ_Post_International_Courier",
                "label": "NZ Post - International Courier",
            },
            {
                "value": "NZ_Post_Parcel_Local",
                "label": "NZ Post - Parcel Local",
            }
        ]
    },
    {
        "value": "Parcelforce",
        "label": "Parcelforce",
        "childNodes": [
            {
                "value": "Parcelforce_Euro_Economy_Dropoff_Dropoff",
                "label": "Parcelforce - Euro Economy Dropoff (Dropoff)",
            },
            {
                "value": "Parcelforce_Euro_Economy_Pickup_Pickup",
                "label": "Parcelforce - Euro Economy Pickup (Pickup)",
            },
            {
                "value": "Parcelforce_Express_09_00_Dropoff",
                "label": "Parcelforce - Express 09:00 (Dropoff)",
            },
            {
                "value": "Parcelforce_Express_09_00_Pickup",
                "label": "Parcelforce - Express 09:00 (Pickup)",
            },
            {
                "value": "Parcelforce_Express_10_00_Dropoff",
                "label": "Parcelforce - Express 10:00 (Dropoff)",
            },
            {
                "value": "Parcelforce_Express_10_00_Pickup",
                "label": "Parcelforce - Express 10:00 (Pickup)",
            },
            {
                "value": "Parcelforce_Express_24_Dropoff",
                "label": "Parcelforce - Express 24 (Dropoff)",
            },
            {
                "value": "Parcelforce_Express_24_Pickup",
                "label": "Parcelforce - Express 24 (Pickup)",
            },
            {
                "value": "Parcelforce_Express_48_Dropoff",
                "label": "Parcelforce - Express 48 (Dropoff)",
            },
            {
                "value": "Parcelforce_Express_48_Large_Pickup",
                "label": "Parcelforce - Express 48 Large (Pickup)",
            },
            {
                "value": "Parcelforce_Express_48_Pickup",
                "label": "Parcelforce - Express 48 (Pickup)",
            },
            {
                "value": "Parcelforce_Express_AM_Dropoff",
                "label": "Parcelforce - Express AM (Dropoff)",
            },
            {
                "value": "Parcelforce_Express_AM_Pickup",
                "label": "Parcelforce - Express AM (Pickup)",
            },
            {
                "value": "Parcelforce_Global_Priority_Dropoff",
                "label": "Parcelforce - Global Priority (Dropoff)",
            },
            {
                "value": "Parcelforce_Global_Priority_Pickup",
                "label": "Parcelforce - Global Priority (Pickup)",
            }
        ]
    },
    {
        "value": "Passport",
        "label": "Passport",
        "childNodes": [
            {
                "value": "Passport_Priority_Delcon",
                "label": "Passport - Priority Delcon",
            },
            {
                "value": "Passport_Priority_Delcon_DDP",
                "label": "Passport - Priority Delcon DDP",
            }
        ]
    },
    {
        "value": "PostNL",
        "label": "PostNL",
        "childNodes": [
            {
                "value": "PostNL_Consolidation_returns",
                "label": "PostNL - Consolidation returns",
            },
            {
                "value": "PostNL_Domestic",
                "label": "PostNL - Domestic",
            },
            {
                "value": "PostNL_Home_pickup",
                "label": "PostNL - Home pickup",
            },
            {
                "value": "PostNL_Home_pickup_bulky",
                "label": "PostNL - Home pickup, bulky",
            },
            {
                "value": "PostNL_International_premium_returns",
                "label": "PostNL - International premium returns",
            },
            {
                "value": "PostNL_International_returns",
                "label": "PostNL - International returns",
            },
            {
                "value": "PostNL_Mailbox_Parcel_Return",
                "label": "PostNL - Mailbox Parcel Return",
            },
            {
                "value": "PostNL_Pakket_Belgium",
                "label": "PostNL - Pakket Belgium",
            }
        ]
    },
    {
        "value": "Purolator",
        "label": "Purolator",
        "childNodes": [
            {
                "value": "Purolator_Express_R",
                "label": "Purolator - Express®",
            },
            {
                "value": "Purolator_Ground_R",
                "label": "Purolator - Ground®",
            }
        ]
    },
    {
        "value": "Quantium",
        "label": "Quantium",
        "childNodes": [
            {
                "value": "Quantium_International_ePAC",
                "label": "Quantium - International ePAC",
            },
            {
                "value": "Quantium_Q_Smart",
                "label": "Quantium - Q-Smart",
            },
            {
                "value": "Quantium_Q_Sure_AU",
                "label": "Quantium - Q-Sure (AU)",
            }
        ]
    },
    {
        "value": "Sendle",
        "label": "Sendle",
        "childNodes": [
            {
                "value": "Sendle_2_Day_Guaranteed_Pickup_Pickup",
                "label": "Sendle - 2 Day Guaranteed Pickup (Pickup)",
            },
            {
                "value": "Sendle_3_Day_Guaranteed_Pickup_Pickup",
                "label": "Sendle 3-Day Guaranteed Pickup (Pickup)",
            },
            {
                "value": "Sendle_Preferred_Drop_Off_Dropoff",
                "label": "Sendle - Preferred Drop Off (Dropoff)",
            },
            {
                "value": "Sendle_Preferred_Pick_up_Pickup",
                "label": "Sendle - Preferred Pick up (Pickup)",
            },
            {
                "value": "Sendle_Preferred_Pickup_Pickup",
                "label": "Sendle - Preferred Pickup (Pickup)",
            },
            {
                "value": "Sendle_Standard_Dropoff",
                "label": "Sendle - Standard Dropoff",
            },
            {
                "value": "Sendle_Standard_Pickup",
                "label": "Sendle - Standard Pickup",
            }
        ]
    },
    {
        "value": "Seur",
        "label": "Seur",
        "childNodes": [
            {
                "value": "SEUR_24_Retorno",
                "label": "SEUR - 24 Retorno",
            },
            {
                "value": "SEUR_48_Retorno_Recogida",
                "label": "SEUR - 48 Retorno + Recogida",
            },
            {
                "value": "SEUR_Classic",
                "label": "SEUR - Classic",
            },
            {
                "value": "SEUR_Retorno",
                "label": "SEUR - Retorno",
            }
        ]
    },
    {
        "value": "SF_Express",
        "label": "SF Express",
        "childNodes": [
            {
                "value": "SF_Express_Domestic",
                "label": "SF Express - Domestic",
            },
            {
                "value": "SF_Express_E_Parcel_Registered_US",
                "label": "SF Express - E-Parcel Registered (US)",
            },
            {
                "value": "SF_Express_Economy_Express",
                "label": "SF Express - Economy Express",
            },
            {
                "value": "SF_Express_Economy_Express_LAX",
                "label": "SF Express - Economy Express (LAX)",
            },
            {
                "value": "SF_Express_Economy_Express_Pickup",
                "label": "SF Express - Economy Express (Pickup)",
            },
            {
                "value": "SF_Express_Local_FSCMOTW",
                "label": "SF Express - Local (FSCMOTW)",
            },
            {
                "value": "SF_Express_Standard_Express_Pickup",
                "label": "SF Express - Standard Express (Pickup)",
                "countries": [
                    "HK",
                    "US"
                ]
            }
        ]
    },
    {
        "value": "Singpost",
        "label": "Singpost",
        "childNodes": [
            {
                "value": "SingPost_International_SpeedPost_Express",
                "label": "SingPost - International SpeedPost Express",
            },
            {
                "value": "SingPost_International_SpeedPost_Priority",
                "label": "SingPost - International SpeedPost Priority",
            },
            {
                "value": "SingPost_NextDay",
                "label": "SingPost - NextDay",
            },
            {
                "value": "Singpost_NSaver",
                "label": "Singpost - NSaver",
            }
        ]
    },
    {
        "value": "SkyPostal",
        "label": "SkyPostal",
        "childNodes": [
            {
                "value": "SkyPostal_Packet_Express",
                "label": "SkyPostal - Packet Express",
            },
            {
                "value": "SkyPostal_Postal_Packet_Standard",
                "label": "SkyPostal - Postal Packet Standard",
            },
            {
                "value": "SkyPostal_Standard_Private_Delivery",
                "label": "SkyPostal - Standard Private Delivery",
            }
        ]
    },
    {
        "value": "Team_Global_Express",
        "label": "Team Global Express",
        "childNodes": [
            {
                "value": "Team_Global_Express_Parcel",
                "label": "Team Global Express - Parcel",
            }
        ]
    },
    {
        "value": "TNT",
        "label": "TNT",
        "childNodes": [
            {
                "value": "TNT_Express_09_00_OWC",
                "label": "TNT - Express 09:00 (OWC)",
            },
            {
                "value": "TNT_Express_10_00_OWC",
                "label": "TNT - Express 10:00 (OWC)",
            },
            {
                "value": "TNT_Express_12_00_OWC",
                "label": "TNT - Express 12:00 (OWC)",
            },
            {
                "value": "TNT_Overnight",
                "label": "TNT - Overnight",
            },
            {
                "value": "TNT_Road_Express",
                "label": "TNT - Road Express",
            }
        ]
    },
    {
        "value": "TracX_Logis",
        "label": "TracX Logis",
        "childNodes": [
            {
                "value": "TracX_Logis_Domestic",
                "label": "TracX Logis - Domestic",
            },
            {
                "value": "TracX_Logis_International",
                "label": "TracX Logis - International",
            },
            {
                "value": "TracX_Logis_International_MYEast",
                "label": "TracX Logis - International (MYEast)",
            }
        ]
    },
    {
        "value": "UPS",
        "label": "UPS",
        "childNodes": [
            {
                "value": "UPS_2nd_Day_Air_A_M_R",
                "label": "UPS 2nd Day Air A.M. ®",
            },
            {
                "value": "UPS_2nd_Day_Air_R",
                "label": "UPS 2nd Day Air®",
            },
            {
                "value": "UPS_3_Day_Select_R",
                "label": "UPS 3 Day Select®",
                "countries": [
                    "US",
                    "CA"
                ]
            },
            {
                "value": "UPS_Expedited",
                "label": "UPS Expedited",
            },
            {
                "value": "UPS_Expedited_R",
                "label": "UPS Expedited®",
            },
            {
                "value": "UPS_Expedited_TM_MyFlyingBox",
                "label": "UPS Expedited™ (MyFlyingBox)",
            },
            {
                "value": "UPS_Express_Early_R",
                "label": "UPS Express Early®",
            },
            {
                "value": "UPS_Express_Plus_R",
                "label": "UPS Express Plus®",
            },
            {
                "value": "UPS_Express_R",
                "label": "UPS Express®",
                "countries": [
                    "CA",
                    "UK"
                ]
            },
            {
                "value": "UPS_Express_Saver_R",
                "label": "UPS Express Saver®",
                "countries": [
                    "CA",
                    "UK"
                ]
            },
            {
                "value": "UPS_Express_Saver_R_OWC",
                "label": "UPS - Express Saver® (OWC)",
            },
            {
                "value": "UPS_Express_Saver_Return",
                "label": "UPS - Express Saver Return",
            },
            {
                "value": "UPS_Next_Day_Air_R",
                "label": "UPS Next Day Air®",
            },
            {
                "value": "UPS_Next_Day_Air_R_Early",
                "label": "UPS Next Day Air® Early",
            },
            {
                "value": "UPS_Next_Day_Air_Saver_R",
                "label": "UPS Next Day Air Saver®",
            },
            {
                "value": "UPS_Premium_Return",
                "label": "UPS - Premium Return",
            },
            {
                "value": "UPS_R_Ground",
                "label": "UPS® Ground",
            },
            {
                "value": "UPS_R_Ground_Saver",
                "label": "UPS® Ground Saver",
            },
            {
                "value": "UPS_R_Ground_Saver_1lb",
                "label": "UPS® Ground Saver (1lb)",
            },
            {
                "value": "UPS_R_Standard",
                "label": "UPS® Standard",
            },
            {
                "value": "UPS_R_Standard_MyFlyingBox",
                "label": "UPS® Standard (MyFlyingBox)",
            },
            {
                "value": "UPS_Standard_R",
                "label": "UPS Standard®",
                "countries": [
                    "CA",
                    "UK"
                ]
            },
            {
                "value": "UPS_Standard_Return",
                "label": "UPS - Standard Return",
            },
            {
                "value": "UPS_Worldwide_Expedited_R",
                "label": "UPS Worldwide Expedited®",
                "countries": [
                    "US",
                    "SG",
                    "CA"
                ]
            },
            {
                "value": "UPS_Worldwide_Expedited_R_Pickup",
                "label": "UPS Worldwide Expedited® (Pickup)",
            },
            {
                "value": "UPS_Worldwide_Express_Plus_R",
                "label": "UPS Worldwide Express Plus®",
                "countries": [
                    "SG",
                    "HK"
                ]
            },
            {
                "value": "UPS_Worldwide_Express_Plus_R_MyFlyingBox",
                "label": "UPS Worldwide Express Plus® (MyFlyingBox)",
            },
            {
                "value": "UPS_Worldwide_Express_Plus_TM",
                "label": "UPS Worldwide Express Plus™",
            },
            {
                "value": "UPS_Worldwide_Express_R",
                "label": "UPS Worldwide Express®",
                "countries": [
                    "US",
                    "SG",
                    "HK"
                ]
            },
            {
                "value": "UPS_Worldwide_Express_Saver_R",
                "label": "UPS Worldwide Express Saver®",
            },
            {
                "value": "UPS_Worldwide_Saver_R",
                "label": "UPS Worldwide Saver®",
                "countries": [
                    "US",
                    "SG",
                    "NZ"
                ]
            },
            {
                "value": "UPS_Worldwide_Saver_R_MyFlyingBox",
                "label": "UPS Worldwide Saver® (MyFlyingBox)",
            },
            {
                "value": "UPS_Worldwide_Saver_R_OWC",
                "label": "UPS - Worldwide Saver® (OWC)",
            },
            {
                "value": "UPS_Worldwide_Saver_R_pickup",
                "label": "UPS Worldwide Saver® (pickup)",
            },
            {
                "value": "UPS_Worldwise_Express_TM",
                "label": "UPS Worldwise Express™",
            }
        ]
    },
    {
        "value": "USPS",
        "label": "USPS",
        "childNodes": [
            {
                "value": "USPS_First_Class_International",
                "label": "USPS - First Class International",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Envelope_Envelope",
                "label": "USPS - Flat Rate Priority Mail - Envelope (Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Express_Envelope_Envelope",
                "label": "USPS - Flat Rate Priority Mail Express - Envelope (Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Express_International_Envelope_Envelope",
                "label": "USPS - Flat Rate Priority Mail Express International - Envelope (Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Express_International_Legal_Envelope_Legal_Envelope",
                "label": "USPS - Flat Rate Priority Mail Express International - Legal Envelope (Legal Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Express_International_Padded_Envelope",
                "label": "USPS - Flat Rate Priority Mail Express International - Padded Envelope",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Express_Legal_Envelope_Legal_Envelope",
                "label": "USPS - Flat Rate Priority Mail Express - Legal Envelope (Legal Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Express_Padded_Envelope_Padded_Envelope",
                "label": "USPS - Flat Rate Priority Mail Express - Padded Envelope (Padded Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Envelope_Envelope",
                "label": "USPS - Flat Rate Priority Mail International - Envelope (Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Large_Large",
                "label": "USPS - Flat Rate Priority Mail International - Large (Large)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Large_Video_Box_Large_Video_Box",
                "label": "USPS - Flat Rate Priority Mail International - Large Video Box (Large Video Box)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Legal_Envelope_Legal_Envelope",
                "label": "USPS - Flat Rate Priority Mail International - Legal Envelope (Legal Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Medium_1_Medium_Box_1",
                "label": "USPS - Flat Rate Priority Mail International - Medium 1 (Medium Box 1)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Medium_2_Medium2",
                "label": "USPS - Flat Rate Priority Mail International - Medium 2 (Medium2)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Padded_Envelope_Padded_Envelope",
                "label": "USPS - Flat Rate Priority Mail International - Padded Envelope (Padded Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Small_Envelope_Small_Envelope",
                "label": "USPS - Flat Rate Priority Mail International - Small Envelope (Small Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Small_Small",
                "label": "USPS - Flat Rate Priority Mail International - Small (Small)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_International_Window_Envelope_Window_Envelope",
                "label": "USPS - Flat Rate Priority Mail International - Window Envelope (Window Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Large",
                "label": "USPS - Flat Rate Priority Mail - Large",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Legal_Envelope_Legal_Envelope",
                "label": "USPS - Flat Rate Priority Mail - Legal Envelope (Legal Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Medium_1_Medium1",
                "label": "USPS - Flat Rate Priority Mail - Medium 1 (Medium1)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Medium_2",
                "label": "USPS - Flat Rate Priority Mail - Medium 2",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Padded_Envelope_USPS",
                "label": "USPS - Flat Rate Priority Mail - Padded Envelope (USPS)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Small_Envelope_Small_Envelope",
                "label": "USPS - Flat Rate Priority Mail - Small Envelope (Small Envelope)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Small_Small",
                "label": "USPS - Flat Rate Priority Mail - Small (Small)",
            },
            {
                "value": "USPS_Flat_Rate_Priority_Mail_Window_Envelope_Window_Envelope",
                "label": "USPS - Flat Rate Priority Mail - Window Envelope (Window Envelope)",
            },
            {
                "value": "USPS_Ground_Advantage",
                "label": "USPS - Ground Advantage",
            },
            {
                "value": "USPS_Ground_Advantage_Signature",
                "label": "USPS - Ground Advantage Signature",
            },
            {
                "value": "USPS_Light_Weight_Trackable",
                "label": "USPS - Light Weight Trackable",
            },
            {
                "value": "USPS_Light_Weight_Trackable_FlatStandard",
                "label": "USPS - Light Weight Trackable (FlatStandard)",
            },
            {
                "value": "USPS_Media",
                "label": "USPS - Media",
            },
            {
                "value": "USPS_Priority_Mail",
                "label": "USPS - Priority Mail",
            },
            {
                "value": "USPS_Priority_Mail_Express",
                "label": "USPS - Priority Mail Express",
            },
            {
                "value": "USPS_Priority_Mail_Express_International",
                "label": "USPS - Priority Mail Express International",
            },
            {
                "value": "USPS_Priority_Mail_International",
                "label": "USPS - Priority Mail International",
            },
            {
                "value": "USPS_Priority_Mail_Signature",
                "label": "USPS - Priority Mail Signature",
            }
        ]
    }
];

const initialValue = [
    {
        "value": "Aramex",
        "label": "Aramex",
        "childNodes": [
            {
                "value": "Aramex_Domestic_Pick_up_to_delivery",
                "label": "Aramex - Domestic (Pick up to delivery)",
            },
            {
                "value": "Aramex_Parcel",
                "label": "Aramex - Parcel",
                "childNodes": [
                    {
                        "value": "Aramex_Parcel_NESTED_1",
                        "label": "Aramex - Aramex_Parcel_NESTED_1",
                    },
                    {
                        "value": "Aramex_Parcel_NESTED_2",
                        "label": "Aramex - Aramex_Parcel_NESTED_2",
                    },
                ]
            },
            {
                "value": "Aramex_Parcel_Domestic",
                "label": "Aramex - Parcel (Domestic)",
                "childNodes": [
                    {
                        "value": "Aramex_Parcel_Domestic_NESTED_1",
                        "label": "Aramex - Domestic Aramex_Parcel_Domestic_NESTED_1",
                        "childNodes": [
                            // {
                            //     "value": "Aramex_Parcel_Domestic_NESTED_1_1",
                            //     "label": "Aramex - Aramex_Parcel_Domestic_NESTED_1_1",
                            // },
                            {
                                "value": "Aramex_Parcel_Domestic_NESTED_1_2",
                                "label": "Aramex - Aramex_Parcel_Domestic_NESTED_1_2",
                            },
                        ]
                    },
                    {
                        "value": "Aramex_Parcel_Domestic_NESTED_2",
                        "label": "Aramex - Aramex_Parcel_Domestic_NESTED_2",
                    },
                ]
            },
            {
                "value": "Aramex_Parcel_EPX_hybrid_EU_and_US",
                "label": "Aramex - Parcel EPX (hybrid EU and US)",
            },
            {
                "value": "Aramex_Parcel_to_SA_and_AE_DDP",
                "label": "Aramex - Parcel to SA and AE (DDP)",
            }
        ]
    },
];


const UsageExamplePageCheckboxesTreeDropdown: React.FC = () => {
    const [isCompressed, setIsCompressed] = useState<boolean>(true);
    const [isCheckboxesListDisabled, setIsCheckboxesListDisabled] = useState<boolean>(false);
    const [isOptionsLoading, setIsOptionsLoading] = useState<boolean>(false);
    const [value, setValue] = useState<ICheckboxesTreeItem[]|undefined>(initialValue);

    const handleChange = (v: ICheckboxesTreeItem[]|undefined) => {
        console.log('onChange', v);
        setValue(v);
    };

    return (
        <div style={{ padding: '20px' }}>
            <h1>CheckboxesTreeDropdown Example Page</h1>

            <Toggle label="isCompressed" checked={isCompressed} onChange={setIsCompressed} />
            <Toggle label="isCheckboxesListDisabled" checked={isCheckboxesListDisabled} onChange={setIsCheckboxesListDisabled} />
            <Toggle label="isOptionsLoading" checked={isOptionsLoading} onChange={setIsOptionsLoading} />

            <hr />

            <CheckboxesTreeDropdown
                compressed={isCompressed}
                options={options}
                value={value}
                searchInputPlaceholder="Select from dropdown..."
                onChange={handleChange}
                isInitiallyAllItemsExpanded={false}
                checkboxesSelectAllText={'Select All'}
                isCheckboxesListDisabled={isCheckboxesListDisabled}
                isSearchInputDisabled={isOptionsLoading}
            />

        </div>
    );
}

export default UsageExamplePageCheckboxesTreeDropdown;
